import { useEffect } from 'react';

/**
 * Dispara getLogsRead uma vez por mudança de pathname (inclui carga inicial / refresh).
 * Não chama para alunos (idType === 4).
 */
export const useLogsReadOnNavigate = (location, user, getLogsRead) => {
  useEffect(() => {
    if (user && user.idType !== 4) {
      getLogsRead();
    }
  }, [location.pathname, user && user.idType, getLogsRead]);
};
